import Call from '../../Call.v2';

const Cpc = {
    get() {
        return Call(`filler/cpc`);
    },

    save(cpc) {
        return Call(`filler/cpc`, 'POST', { cpc });
    },
};

export default Cpc;


// WEBPACK FOOTER //
// ./src/services/API/components/Filler/Cpc.js